import { render, staticRenderFns } from "./EditModeSelector.vue?vue&type=template&id=48b7ea8a&scoped=true"
import script from "./EditModeSelector.vue?vue&type=script&lang=js"
export * from "./EditModeSelector.vue?vue&type=script&lang=js"
import style0 from "./EditModeSelector.vue?vue&type=style&index=0&id=48b7ea8a&prod&scoped=true&lang=css"
import style1 from "./EditModeSelector.vue?vue&type=style&index=1&id=48b7ea8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b7ea8a",
  null
  
)

export default component.exports